<div class="app-spinner-container" *ngIf="isLoading() | async">
  <mat-spinner [diameter]="40"></mat-spinner>
</div>

<form #fRefertoForm [formGroup]="refForm" novalidate target="Referto" method="GET" class="app-search-form">
  <input type="hidden" name="scope" value="mmn">
  <mat-card class="shipping-card">
    <mat-card-header>
      <mat-card-title>Inserire gli estremi del referto</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <div class="col">
          <!--
          <mat-form-field class="full-width">
          <mat-form-field style="width: 40%;">
          [ngStyle.xs]="{width: '100%'}"
          -->
          <mat-form-field style="width: 50%;">
            <!-- placeholder="USERNAME" -->
            <input matInput #fUsername [placeholder]="usernameLabel" formControlName="username" name="username" autocomplete="off"
                   [ngClass.xs]="'app-xs-font-size'">
            <mat-error *ngIf="refForm.controls['username'].hasError('required')">
              Username non impostato
            </mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <mat-form-field style="width: 50%;">
            <input [type]="passwordHide ? 'password' : 'text'" matInput #fPin [placeholder]="pinLabel" formControlName="pin" name="pin" autocomplete="off"
                   [ngClass.xs]="'app-xs-font-size'">
            <mat-error *ngIf="refForm.controls['pin'].hasError('required')">
              Pin non impostato
            </mat-error>
            <mat-icon matSuffix (click)="passwordHide = !passwordHide">{{passwordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </mat-form-field>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions>
      <button mat-raised-button color="primary" (click)="onButtonClicked(fRefertoForm)" style="min-width: 10rem;" [ngStyle.xs]="{'min-width': 'unset'}">CERCA REFERTO</button>
    </mat-card-actions>
  </mat-card>
</form>

<div #singoloRefertoTrovato *ngIf="visualizzaRefertoSingolo">
  <mat-card class="referto-trovato-card">
    <mat-card-header>
      <mat-card-title>Referto trovato:</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div fxLayout="row">
        <div fxFlex="25%">
          <button class="button2" mat-raised-button color="primary" (click)="mostraRefertoSingolo()">VISUALIZZA REFERTO</button>
        </div>
      </div>
      <div fxLayout="row">
        <div fxFlex="25%">
          <button class="button2" mat-raised-button color="primary" (click)="cancellaRefertoSingolo()">CANCELLA REFERTO</button>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>

<div #listaRefertiTrovati *ngIf="visualizzaRefertiList">
  <app-referti-list></app-referti-list>
</div>

<div #reportContainer [ngStyle]="{'height': 'calc(100% - 40px)'}"></div>

<iframe #iframeReportContainer border="0" bordercolor="#000000" frameborder="0"
        height="0" hspace="0" vspace="0" width="0"></iframe>

<div *ngIf="gestioneGradimentoLIS">
  <div class="app-search-form" style="margin-top: -1rem;">
    <mat-card class="shipping-card">
      <mat-card-header>
        <mat-card-title>Esprimi un giudizio su questo servizio</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div fxLayout="row" *ngIf="!gradimentoLISInviato">
          <p style="font-style: italic; color: #3f51b5; font-size: 12px; width: 100%;">
            Si tratta solo di un sondaggio che verrà utilizzato per migliorare il nostro ospedale.<br>
            Vi ringraziamo anticipatamente per dedicarci 20 secondi del vostro tempo.<br>
            Vi ricordiamo che il questionario è anonimo.</p>
        </div>
        <div fxLayout="row" *ngIf="!gradimentoLISInviato">
          <div fxFlex="25%">
            <div fxFlex="33%">
              <img src="assets/images/lis-grad-1.png" class="lis-icon" (click)="onGradLisIconSelected($event)" id="grad-1" />
            </div>
            <div fxFlex="33%">
              <img src="assets/images/lis-grad-2.png" class="lis-icon" (click)="onGradLisIconSelected($event)" id="grad-2" />
            </div>
            <div fxFlex="33%">
              <img src="assets/images/lis-grad-3.png" class="lis-icon" (click)="onGradLisIconSelected($event)" id="grad-3" />
            </div>
          </div>
        </div>
        <div fxLayout="row" *ngIf="gradimentoLISInviato">
          <span style="font-size: 16px; font-weight: 400; margin-left: 1.2rem;">Grazie del feedback!</span>
        </div>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button color="primary" style="min-width: 10rem;" [ngStyle.xs]="{'min-width': 'unset'}" [disabled]="!valueGradimentoLIS" (click)="onGradLisSendButton()"
                *ngIf="!gradimentoLISInviato">INVIA</button>
      </mat-card-actions>
    </mat-card>
  </div>

</div>